import { Navigate, Route, Routes } from "react-router-dom";

import { isAuthenticated } from "../utils/auth";

import { Banks } from "../pages/SalesManagement/EnterpriseSettings/Banks/Banks";
import { Wallet } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Wallet";
import { BankOfBrazil } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/BankOfBrazil";
import { Santander } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Santander";
import { Sicredi } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Sicredi";
import { Safra } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Safra";
import { Itau } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Itau";
import { Caixa } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Caixa";
import { Sicoob } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Sicoob";
import { Bradesco } from "../pages/SalesManagement/EnterpriseSettings/Banks/BankApproval/Bradesco";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const BanksRoute = () => (
  <PrivateRoute>
    <Routes>
      <Route path="/:id" element={<Banks />} />
      <Route path="/wallet_ib/:id" element={<Wallet />} />
      <Route path="/bb/:id" element={<BankOfBrazil />} />
      <Route path="/santander/:id" element={<Santander />} />
      <Route path="/sicredi/:id" element={<Sicredi />} />
      <Route path="/safra/:id" element={<Safra />} />
      <Route path="/itau/:id" element={<Itau />} />
      <Route path="/caixa/:id" element={<Caixa />} />
      <Route path="/sicoob/:id" element={<Sicoob />} />
      <Route path="/bradesco/:id" element={<Bradesco />} />
    </Routes>
  </PrivateRoute>
);
